import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { MtnaDataType } from '@mtna/data-core-ts';

import { RdsDataTypeUtil } from '../utils/data-type-util';

@Pipe({
  name: 'rdsIsDataTypeText',
})
export class RdsIsDataTypeTextPipe implements PipeTransform {
  transform(value: MtnaDataType | string | null | undefined): boolean {
    return RdsDataTypeUtil.isMtnaDataTypeText(value);
  }
}

@NgModule({
  declarations: [RdsIsDataTypeTextPipe],
  exports: [RdsIsDataTypeTextPipe],
})
export class RdsIsDataTypeTextPipeModule {}
